/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./live_cashout_modal";
import * as i2 from "../tournaments/services/tournaments.service";
var styles_LiveCashoutModal = [];
var RenderType_LiveCashoutModal = i0.ɵcrt({ encapsulation: 2, styles: styles_LiveCashoutModal, data: {} });
export { RenderType_LiveCashoutModal as RenderType_LiveCashoutModal };
export function View_LiveCashoutModal_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "ui modal"], ["id", "Live_Cashout_Modal"]], null, null, null, null, null))], null, null); }
export function View_LiveCashoutModal_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "comp_live_cashout_modal", [], null, null, null, View_LiveCashoutModal_0, RenderType_LiveCashoutModal)), i0.ɵdid(1, 114688, null, 0, i1.LiveCashoutModal, [i2.TournamentsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var LiveCashoutModalNgFactory = i0.ɵccf("comp_live_cashout_modal", i1.LiveCashoutModal, View_LiveCashoutModal_Host_0, {}, { systemSlipChangeAmount: "systemSlip_ChangeAmount" }, []);
export { LiveCashoutModalNgFactory as LiveCashoutModalNgFactory };
